import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { postTenant } from "../api";

export const useCreateTenant = () => {
  const router = useNavigate();
  const queryClient = useQueryClient();
  const { mutate, isPending } = useMutation({
    mutationFn: postTenant,
    onSuccess() {
      queryClient.refetchQueries({ queryKey: ["TENANT"] });
      router("/tenant");
      toast.success("Success Create Tenant");
    },
  });

  return { create: mutate, isPending };
};
